import React, {
  Component
} from 'react';
import NavBar from './components/Navbar/Navbar';
import HeroContainer from './components/Hero/HeroContainer';
import Footer from './components/Footer/Footer';
import Body from './components/Body/Body';





class VisitorIndex extends Component {
  render() {
    return (
      <div>
        <NavBar />
        <HeroContainer />
        <Body />
        <Footer />
      </div>
    )
  }
}

export default VisitorIndex